/**
 * Membership PDP: gallery, billing toggle, retreat picker, sticky bar.
 */
(function () {
  var root = document.querySelector('[data-foc-pdp]');
  if (!root) return;

  var configEl = root.querySelector('[data-foc-pdp-config]');
  if (!configEl) return;

  var config;
  try {
    config = JSON.parse(configEl.textContent);
  } catch (e) {
    return;
  }

  var billing = config.defaultBilling === 'monthly' ? 'monthly' : 'annual';

  function stripMissingPickerError() {
    var scope = document.getElementById('buy') || root;
    if (!scope) return;
    var walker = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT, null);
    var dead = [];
    while (walker.nextNode()) {
      if (/foc-pdp-retreat-picker\.liquid/i.test(walker.currentNode.nodeValue || '')) {
        dead.push(walker.currentNode);
      }
    }
    dead.forEach(function (node) {
      node.nodeValue = '';
    });
  }
  stripMissingPickerError();

  var planBtns = root.querySelectorAll('[data-pdp-billing]');
  var addonInput = root.querySelector('[data-pdp-addon]');
  var retreatDialog = root.querySelector('[data-pdp-retreat-dialog]');
  var retreatCloseEls = root.querySelectorAll('[data-pdp-retreat-close]');
  var retreatCards = root.querySelectorAll('[data-pdp-retreat]');
  var jsDialog = null;
  var retreatsLoaded = false;
  var selectedVariantId = null;
  var ctaEls = root.querySelectorAll('[data-pdp-cta]');
  var noteEls = root.querySelectorAll('[data-pdp-note]');
  var priceEls = root.querySelectorAll('[data-pdp-price]');
  var suffixEls = root.querySelectorAll('[data-pdp-suffix]');
  var sticky = root.querySelector('[data-pdp-sticky]');
  var thumbs = root.querySelectorAll('[data-pdp-thumb]');
  var mainImg = root.querySelector('[data-pdp-main-image], .foc-pdp-hero__main-img');
  var mainWrap = root.querySelector('[data-pdp-main]');

  var MEMBERSHIP_PLANS = {
    monthly: { id: '44781568000135', sellingPlan: '2597748871', discount: 'XQ1RQMR7XE76' },
    annual: { id: '44781568032903', sellingPlan: '3472752775', discount: '' },
  };
  var RETREAT_DISCOUNT = 'W9RNS4KXQWNX';
  var RETREAT_COLLECTION = '/collections/retreats/products.json';

  function showDialog(dialog) {
    if (!dialog) return;
    if (typeof dialog.showModal === 'function') {
      if (!dialog.open) dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
    }
  }

  function hideDialog(dialog) {
    if (!dialog) return;
    if (typeof dialog.close === 'function' && dialog.open) {
      dialog.close();
    } else {
      dialog.removeAttribute('open');
    }
  }

  function formatMoney(amount) {
    var value = Number(amount);
    if (isNaN(value)) return '';
    return '$' + value.toLocaleString('en-US', { maximumFractionDigits: 0 });
  }

  function checkoutUrlForRetreat(variantId) {
    var plan = MEMBERSHIP_PLANS[billing] || MEMBERSHIP_PLANS.monthly;
    var codes = [plan.discount, RETREAT_DISCOUNT].filter(Boolean).join(',');
    var checkout = codes ? '/checkout?discount=' + encodeURIComponent(codes) : '/checkout';
    var add =
      '/cart/add?items[][id]=' +
      plan.id +
      '&items[][quantity]=1&items[][selling_plan]=' +
      plan.sellingPlan +
      '&items[][id]=' +
      variantId +
      '&items[][quantity]=1&return_to=' +
      encodeURIComponent(checkout);
    return '/cart/clear?return_to=' + encodeURIComponent(add);
  }

  function retreatDateFromProduct(product) {
    var source = ((product && product.body_html) || '').replace(/<[^>]+>/g, ' ');
    var match = source.match(/Date:\s*([A-Za-z]+[^.]{0,40}?\d{4})/i);
    if (match) return match[1].replace(/\s+/g, ' ').trim();
    return '';
  }

  function ensureJsDialog() {
    if (jsDialog) return jsDialog;
    jsDialog = document.createElement('dialog');
    jsDialog.className = 'foc-pdp-retreat';
    jsDialog.setAttribute('data-pdp-retreat-dialog-js', '');
    jsDialog.innerHTML =
      '<div class="foc-pdp-retreat__panel">' +
      '<button type="button" class="foc-pdp-retreat__close" data-pdp-retreat-close aria-label="Close"><span aria-hidden="true">&times;</span></button>' +
      '<h2 class="foc-pdp-retreat__title">Choose a retreat</h2>' +
      '<p class="foc-pdp-retreat__sub">15% off applies at checkout</p>' +
      '<ul class="foc-pdp-retreat__list" data-pdp-retreat-list role="list"></ul>' +
      '</div>';
    document.body.appendChild(jsDialog);
    jsDialog.addEventListener('click', function (event) {
      if (event.target === jsDialog) closeRetreatDialog();
    });
    jsDialog.addEventListener('close', syncCheckboxFromSelection);
    var closeBtn = jsDialog.querySelector('[data-pdp-retreat-close]');
    if (closeBtn) closeBtn.addEventListener('click', closeRetreatDialog);
    return jsDialog;
  }

  function renderRetreatCards(products) {
    var list = jsDialog && jsDialog.querySelector('[data-pdp-retreat-list]');
    if (!list) return;
    list.innerHTML = '';
    var available = (products || []).filter(function (product) {
      return product.variants && product.variants.some(function (variant) { return variant.available; });
    });
    if (!available.length) {
      list.innerHTML = '<li class="foc-pdp-retreat__empty">No retreats are available right now.</li>';
      return;
    }
    available.forEach(function (product) {
      var variant = product.variants.filter(function (item) { return item.available; })[0];
      if (!variant) return;
      var full = Number(variant.price);
      var member = full * 0.85;
      var date = retreatDateFromProduct(product);
      var item = document.createElement('li');
      item.innerHTML =
        '<button type="button" class="foc-pdp-retreat__card" data-pdp-retreat-js data-variant-id="' +
        variant.id +
        '">' +
        '<span class="foc-pdp-retreat__card-name"></span>' +
        (date ? '<span class="foc-pdp-retreat__card-date"></span>' : '') +
        '<span class="foc-pdp-retreat__card-price">' +
        '<s class="foc-pdp-retreat__card-was"></s>' +
        '<span class="foc-pdp-retreat__card-now"></span>' +
        '<span class="foc-pdp-retreat__card-save">15% off</span>' +
        '</span></button>';
      item.querySelector('.foc-pdp-retreat__card-name').textContent = product.title;
      if (date) item.querySelector('.foc-pdp-retreat__card-date').textContent = date;
      item.querySelector('.foc-pdp-retreat__card-was').textContent = formatMoney(full);
      item.querySelector('.foc-pdp-retreat__card-now').textContent = formatMoney(member);
      item.querySelector('[data-pdp-retreat-js]').addEventListener('click', function () {
        confirmRetreat(variant.id);
      });
      list.appendChild(item);
    });
  }

  function openJsPicker() {
    ensureJsDialog();
    showDialog(jsDialog);
    if (retreatsLoaded) return;
    fetch(RETREAT_COLLECTION)
      .then(function (response) { return response.json(); })
      .then(function (data) {
        retreatsLoaded = true;
        renderRetreatCards(data.products || []);
      })
      .catch(function () {
        renderRetreatCards([]);
      });
  }

  function openRetreatDialog() {
    openJsPicker();
  }

  function syncAddon() {
    if (!addonInput) return;
    var addonLabel = addonInput.closest('.foc-pdp-hero__addon');
    if (addonLabel) addonLabel.classList.toggle('is-checked', addonInput.checked);
  }

  function syncCheckboxFromSelection() {
    if (!addonInput) return;
    addonInput.checked = !!selectedVariantId;
    syncAddon();
  }

  function confirmRetreat(variantId) {
    selectedVariantId = variantId;
    syncCheckboxFromSelection();
    hideDialog(retreatDialog);
    hideDialog(jsDialog);
  }

  function closeRetreatDialog() {
    hideDialog(retreatDialog);
    hideDialog(jsDialog);
    syncCheckboxFromSelection();
  }

  function resolveUrl(state) {
    if (window.FOCFreeGift && typeof window.FOCFreeGift.pickUrl === 'function') {
      return window.FOCFreeGift.pickUrl(state.url, state.giftUrl);
    }
    return state.url;
  }

  function sync() {
    var state = config[billing];
    if (!state) return;

    planBtns.forEach(function (btn) {
      var active = btn.getAttribute('data-pdp-billing') === billing;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });

    priceEls.forEach(function (el) {
      el.textContent = state.price;
    });
    suffixEls.forEach(function (el) {
      el.textContent = state.suffix;
    });
    noteEls.forEach(function (el) {
      el.textContent = state.note;
    });

    root.querySelectorAll('[data-pdp-sub]').forEach(function (el) {
      if (state.sub) el.textContent = state.sub;
    });
    root.querySelectorAll('[data-pdp-monthly-only]').forEach(function (el) {
      el.hidden = billing !== 'monthly';
    });
    root.querySelectorAll('[data-pdp-annual-only]').forEach(function (el) {
      el.hidden = billing !== 'annual';
    });
    root.querySelectorAll('[data-pdp-sticky-price]').forEach(function (el) {
      if (state.stickyPrice) el.textContent = state.stickyPrice;
    });
    root.querySelectorAll('[data-pdp-sticky-note]').forEach(function (el) {
      if (state.stickyNote) el.textContent = state.stickyNote;
    });

    ctaEls.forEach(function (el) {
      var action = el.getAttribute('data-pdp-cta');
      if (action === 'closing') return;
      if (action === 'sticky_cta') {
        if (state.stickyCta) el.textContent = state.stickyCta;
      } else {
        el.textContent = state.cta;
      }
      el.setAttribute('href', resolveUrl(state));
      el.setAttribute('data-billing', billing);
    });
  }

  function planValue() {
    var state = config[billing];
    if (!state || !state.price) return undefined;
    var num = parseFloat(String(state.price).replace(/[^0-9.]/g, ''));
    return isNaN(num) ? undefined : num;
  }

  function currentPlan() {
    return MEMBERSHIP_PLANS[billing] || MEMBERSHIP_PLANS.monthly;
  }

  function commerceParams() {
    var value = planValue();
    var params = {
      content_name: 'Founders Only Premium',
      content_ids: [String(currentPlan().id)],
      content_type: 'product',
      content_category: billing,
      currency: 'USD',
      num_items: 1,
    };
    if (value != null) params.value = value;
    return params;
  }

  function gaParams(extra) {
    var value = planValue();
    var item = {
      item_id: String(currentPlan().id),
      item_name: 'Founders Only Premium',
      item_variant: billing,
      quantity: 1,
    };
    if (value != null) item.price = value;
    var params = {
      currency: 'USD',
      items: [item],
    };
    if (value != null) params.value = value;
    if (extra) {
      Object.keys(extra).forEach(function (key) {
        params[key] = extra[key];
      });
    }
    return params;
  }

  function sendFbq(method, name, params, attemptsLeft) {
    if (typeof window.fbq === 'function') {
      try {
        window.fbq(method, name, params);
      } catch (e) {
        /* analytics must not block checkout */
      }
      return;
    }
    if (!attemptsLeft) return;
    setTimeout(function () {
      sendFbq(method, name, params, attemptsLeft - 1);
    }, 400);
  }

  function sendGtag(name, params, attemptsLeft) {
    if (typeof window.gtag === 'function') {
      try {
        window.gtag('event', name, params);
      } catch (e) {
        /* analytics must not block checkout */
      }
      return;
    }
    if (!attemptsLeft) return;
    setTimeout(function () {
      sendGtag(name, params, attemptsLeft - 1);
    }, 400);
  }

  function trackView() {
    sendFbq('track', 'ViewContent', commerceParams(), 8);
    sendGtag('view_item', gaParams(), 8);
  }

  function track(action, done) {
    var payload = {
      event: config.offer ? 'pdp_cta_click' : 'membership_cta_click',
      variant: 'pdp',
      billing: billing,
      action: action,
    };
    if (config.offer) payload.offer = config.offer;
    if (typeof done === 'function') {
      payload.eventCallback = done;
      payload.eventTimeout = 1200;
    }
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);

    if (action !== 'buybox_cta' && action !== 'sticky_cta') return;

    var value = planValue();
    var joinParams = {
      content_name: 'Founders Only Premium',
      content_category: billing,
      placement: action,
      currency: 'USD',
    };
    if (value != null) joinParams.value = value;
    var standard = commerceParams();

    sendFbq('trackCustom', 'JoinClick', joinParams, 4);
    sendFbq('track', 'AddToCart', standard, 4);
    sendFbq('track', 'InitiateCheckout', standard, 4);
    sendGtag('join_click', gaParams({ billing: billing, placement: action, item_variant: billing }), 4);
    sendGtag('add_to_cart', gaParams(), 4);
    sendGtag('begin_checkout', gaParams(), 4);

    if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
      try {
        Shopify.analytics.publish('foc_join_click', joinParams);
      } catch (e) {
        /* analytics must not block checkout */
      }
    }
  }

  planBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      billing = btn.getAttribute('data-pdp-billing') || billing;
      sync();
    });
  });

  ctaEls.forEach(function (el) {
    el.addEventListener('click', function (event) {
      var action = el.getAttribute('data-pdp-cta') || 'buybox_cta';
      if (action === 'closing') {
        track(action);
        var buy = document.getElementById('buy');
        if (buy) buy.scrollIntoView({ behavior: 'smooth' });
        return;
      }
      if (addonInput && addonInput.checked && selectedVariantId) {
        event.preventDefault();
        track(action);
        window.location.href = checkoutUrlForRetreat(selectedVariantId);
        return;
      }
      if (addonInput && addonInput.checked) {
        event.preventDefault();
        track(action);
        openRetreatDialog();
        return;
      }
      var href = el.getAttribute('href');
      var modified = event.metaKey || event.ctrlKey || event.shiftKey || event.altKey;
      if (!href || event.button !== 0 || modified || el.getAttribute('target') === '_blank') {
        track(action);
        return;
      }
      event.preventDefault();
      var left = false;
      function go() {
        if (left) return;
        left = true;
        window.location.href = href;
      }
      track(action, go);
      setTimeout(go, 1500);
    });
  });

  if (addonInput) {
    addonInput.addEventListener('click', function (event) {
      if (addonInput.checked && !selectedVariantId) {
        event.preventDefault();
        addonInput.checked = false;
        syncAddon();
        openRetreatDialog();
        return;
      }
      if (!addonInput.checked) {
        selectedVariantId = null;
        closeRetreatDialog();
      }
    });
    syncAddon();
  }

  retreatCloseEls.forEach(function (el) {
    el.addEventListener('click', closeRetreatDialog);
  });

  if (retreatDialog) {
    retreatDialog.addEventListener('click', function (event) {
      if (event.target === retreatDialog) closeRetreatDialog();
    });
    retreatDialog.addEventListener('close', syncCheckboxFromSelection);
  }

  retreatCards.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var variantId = btn.getAttribute('data-variant-id');
      if (variantId) confirmRetreat(variantId);
    });
  });

  thumbs.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var src = btn.getAttribute('data-src');
      var srcset = btn.getAttribute('data-srcset');
      var alt = btn.getAttribute('data-alt') || '';
      if (mainImg && src) {
        mainImg.setAttribute('src', src);
        if (srcset) mainImg.setAttribute('srcset', srcset);
        else mainImg.removeAttribute('srcset');
        mainImg.setAttribute('alt', alt);
      }
      if (mainWrap) mainWrap.classList.toggle('is-graphic', btn.getAttribute('data-pdp-frame') === 'graphic');
      thumbs.forEach(function (thumb) {
        thumb.classList.toggle('is-active', thumb === btn);
      });
    });
  });

  if (sticky) {
    var onScroll = function () {
      var visible = window.scrollY > 700;
      sticky.classList.toggle('is-visible', visible);
      sticky.setAttribute('aria-hidden', visible ? 'false' : 'true');
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  if (mainWrap) {
    mainWrap.addEventListener('keydown', function (event) {
      if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
      var list = Array.prototype.slice.call(thumbs);
      if (!list.length) return;
      var current = list.findIndex(function (thumb) {
        return thumb.classList.contains('is-active');
      });
      if (current < 0) current = 0;
      var next = event.key === 'ArrowRight' ? current + 1 : current - 1;
      if (next < 0) next = list.length - 1;
      if (next >= list.length) next = 0;
      list[next].click();
    });
  }

  sync();
  trackView();
})();
